'use strict';

var _ = require('lodash');
var PendingUserRequestService = function PendingUserRequestService(restangular) {
  function sendConfirmEmail(status, toUser, confirmMessage) {
    var emailInformation = emailMessagePayload(status, toUser, confirmMessage);
    return restangular.one('ancillary').one('email').customPOST(emailInformation);
  }
  function approveUser(user, isActive, role) {
    var updateUser = prepareUserPayload(user, isActive, role);
    return restangular.one('user').customPUT(updateUser);
  }
  function rejectUser(userId) {
    return restangular.one('user').customDELETE(userId);
  }
  function getRoles() {
    var result = [];
    return restangular.one('users').one('nonadminroles').get().then(function (roles) {
      _.forEach(roles.roles, function (userRoles) {
        _.forEach(userRoles.roles, function (role) {
          result.push(role);
        });
      });
      return _.uniq(result);
    });
  }
  function emailMessagePayload(status, to, message) {
    var emailAndMessage = {};
    if (status === true) {
      emailAndMessage = {
        'from': 'doNotReply@sabre.com',
        'recipients': [to.email],
        'body': message,
        'subject': 'AirVision Revenue Optimizer Access Request: Approved'
      };
    } else {
      emailAndMessage = {
        'from': 'doNotReply@sabre.com',
        'recipients': [to.email],
        'body': message,
        'subject': ' AirVision Revenue Optimizer Access Request: Denied'
      };
    }
    return emailAndMessage;
  }
  function prepareUserPayload(userData, isActive, role) {
    var updateUserData = {
      'userId': userData.userId,
      'roles': [role],
      'isActive': isActive,
      'organization': userData.organization,
      'isSabreEmployee': userData.isSabreEmployee,
      'isSystemOwner': userData.isSystemOwner,
      'firstName': userData.firstName,
      'lastName': userData.lastName,
      'email': userData.email,
      'cityCode': userData.cityCode,
      'responsibilities': {
        'markets': userData.responsibilities.markets,
        'legs': userData.responsibilities.legs
      },
      'preferences': {
        'markets': userData.preferences.markets,
        'legs': userData.preferences.legs,
        'workflowSettings': userData.preferences.workflowSettings || null,
        'dateTimeNumberFormatSettings': userData.preferences.dateTimeNumberFormatSettings || []
      }
    };
    return updateUserData;
  }
  return {
    sendConfirmEmail: sendConfirmEmail,
    approveUser: approveUser,
    rejectUser: rejectUser,
    getRoles: getRoles
  };
};
PendingUserRequestService.$inject = ['Restangular'];
module.exports = PendingUserRequestService;